import React from "react";

const Spinner = ({ small, dark }) => {
    return (
        <div className={`Loader ${dark ? "Loader--dark" : ""} ${small ? "Loader--small" : ""}`}>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
            <i></i>
        </div>
    );
};
export default Spinner;
